var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.65718 14.0541C4.79659 14.0541 3.22208 13.3737 1.93366 12.013C0.645235 10.6523 0.00068333 8.99027 5.41895e-07 7.02703C-0.000682246 5.06378 0.64387 3.4018 1.93366 2.04108C3.22344 0.68036 4.79795 0 6.65718 0C8.51642 0 10.0913 0.68036 11.3817 2.04108C12.6722 3.4018 13.3164 5.06378 13.3144 7.02703C13.3144 7.81982 13.1949 8.56757 12.9559 9.27027C12.7169 9.97297 12.3926 10.5946 11.9829 11.1351L17.7183 17.1892C17.9061 17.3874 18 17.6396 18 17.9459C18 18.2523 17.9061 18.5045 17.7183 18.7027C17.5306 18.9009 17.2916 19 17.0014 19C16.7112 19 16.4723 18.9009 16.2845 18.7027L10.5491 12.6486C10.037 13.0811 9.44808 13.4234 8.78236 13.6757C8.11664 13.9279 7.40825 14.0541 6.65718 14.0541ZM6.65718 11.8919C7.93741 11.8919 9.02578 11.4191 9.92228 10.4735C10.8188 9.52793 11.2667 8.3791 11.266 7.02703C11.2653 5.67495 10.8174 4.52649 9.92228 3.58162C9.02714 2.63676 7.93878 2.1636 6.65718 2.16216C5.37559 2.16072 4.28757 2.63387 3.39312 3.58162C2.49866 4.52937 2.05041 5.67784 2.04836 7.02703C2.04632 8.37622 2.49457 9.52504 3.39312 10.4735C4.29167 11.422 5.37969 11.8948 6.65718 11.8919Z",
    fill: "#364098"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.2be642949d2567476665afe223d52ed7.svg";
export { ForwardRef as ReactComponent };